import { cartLinesListHeaderStyles } from "@insite/content-library/Components/CartLinesListHeader";
import { css } from "styled-components";

cartLinesListHeaderStyles.productCountText = {
    css: css`
        display: flex;
        align-items: center;
    `,
};
cartLinesListHeaderStyles.checkboxGroup = {
    css: css`
        display: flex;
        flex-direction: row;
        display: none;
    `,
};

cartLinesListHeaderStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        border-bottom: none;
        padding-bottom: 10px;
    `,
};